/** Cadastra um novo tipo de acordo */
import React, { Component } from "react";
import { Modal, Checkbox, notification } from "antd";
import api from "../../../../../services/api";
import handleError from "../../../../../services/apiErrorHandler";

export default class Cadastro extends Component {
  /**
   * Cadastro de um novo tipo de acordo
   */
  state = {
    sucumbencial: false,
    loading: false
  };

  handleCheckboxChange = event => {
    this.setState({
      sucumbencial: event.target.checked
    });
  };

  handleCadastro = async () => {
    var tipo_acordo = document.getElementById("tipo_acordo").value;
    var porcentagem = document.getElementById("porcentagem_honor").value;
    var sucumbencial = this.state.sucumbencial;

    if (tipo_acordo == null || tipo_acordo.length <= 0) {
      Modal.error({
        title: "Error",
        content: "Tipo do acordo inválido."
      });
      return;
    }

    if (porcentagem == null || porcentagem.length <= 0) porcentagem = 0;

    if (/[^0-9,.]/g.test(String(porcentagem))) {
      Modal.error({
        title: "Erro",
        content: "Porcentagem inválida!"
      });
      return;
    }

    porcentagem = String(porcentagem).replace(/[,]/g, ".");

    if (isNaN(parseFloat(porcentagem))) {
      Modal.error({
        title: "Erro",
        content: "Porcentagem inválida!"
      });
      return;
    }

    if (parseFloat(porcentagem) > 100 || parseFloat(porcentagem) < 0) {
      Modal.error({
        title: "Erro",
        content: "Porcentagem inválida!"
      });
      return;
    }

    this.setState({
      loading: true
    });

    await api
      .post("/tipo_acordo/", {
        tipo: tipo_acordo,
        porcentagem_honorarios: parseFloat(porcentagem),
        honorarios_sucumbenciais: sucumbencial
      })
      .then(() => {
        notification.success({
          message: "Cadastrado com sucesso!"
        });

        this.props.handleCadastroCancel();

        this.props.handleTypes();

        document.getElementById("tipo_acordo").value = null;
        document.getElementById("porcentagem_honor").value = null;

        this.setState({
          sucumbencial: false
        });
      })
      .catch(err => {
        Modal.error({
          title: "Error",
          content: handleError(err)
        });
      });

    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <Modal
        visible={this.props.visible}
        okText="Salvar"
        cancelText="Cancelar"
        onOk={this.handleCadastro}
        onCancel={this.props.handleCadastroCancel}
        title="Cadastrar tipo de acordo"
      >
        <div>
          <label>Tipo do acordo:</label>
          <input
            style={{ marginTop: "5px" }}
            type="text"
            className="ant-input"
            id="tipo_acordo"
          />
        </div>
        <br />
        <div style={{ display: "flex" }}>
          <div style={{ width: "50%" }}>
            <label>Porcentagem honorários:</label>
            <input
              style={{ marginTop: "5px" }}
              type="text"
              className="ant-input"
              id="porcentagem_honor"
            />
          </div>
          <div style={{ width: "50%", marginLeft: "15px" }}></div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Configuracoes/Acordo/TiposAcordo/Cadastro/index.js